import React, { useState } from 'react';
import { KompisLanguageSelector } from '@inter-ikea-kompis/react-components';
import LanguageSelectorModalEnum from '@inter-ikea-kompis/component-language-selector/lib/enums/LanguageSelectorModalEnum';
import LanguageSelectorSizeEnum from '@inter-ikea-kompis/component-language-selector/lib/enums/LanguageSelectorSizeEnum';
import { SpaceProps } from 'styled-system';
import Box from 'ui/Box';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { useServiceSettings } from 'contexts/serviceSettings';

type Props = SpaceProps & {
  onChange: (event?: any) => void;
  locale: string;
};

const LanguageSelector = ({ onChange, locale, ...props }: Props) => {
  const { translations, dexfSettings } = useServiceSettings();
  const [visibleModal, setVisibleModal] = useState<LanguageSelectorModalEnum | undefined>(
    undefined
  );
  return (
    <Box {...props}>
      <KompisLanguageSelector
        translations={translations.kompis}
        settings={dexfSettings}
        theme={SkapaTheme}
        locale={locale}
        onChange={onChange}
        visibleModal={visibleModal}
        onModalOpen={() => setVisibleModal(LanguageSelectorModalEnum.languageSelectorPopover)}
        onModalClose={() => setVisibleModal(undefined)}
        buttonSize={LanguageSelectorSizeEnum.medium}
      />
    </Box>
  );
};

export default LanguageSelector;
